import React, { Component } from 'react';
import {Modal} from 'react-bootstrap';
import Form from 'components/react-validation/components/form';
import Submit from 'components/react-validation/components/submit';
import Input from 'components/react-validation/components/input';
// import Modal from 'components/modal';
import * as Vali from 'helper/validator-helper';
import PropTypes from 'prop-types';
import * as InsurancePolicyActionType from '../constants';

export class AddEditInsurancePolicy extends Component {
  static propTypes = {
    onSubmit: PropTypes.func,
    onCloseModal: PropTypes.func,
    isOpenFormAddEdit: PropTypes.bool,
    isCreate: PropTypes.bool,
    show: PropTypes.bool,
    item: PropTypes.object,
    title: PropTypes.string,
    errorMsg: PropTypes.array
  }
  constructor(props) {
    super(props);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.show && this.form) {
      this.form.resetForm(this.refs);

      if (nextProps.errorMsg.length > 0) {
        this.form.showError(this.refs['name'], nextProps.errorMsg[0].error);
      }

    }
  }

  onSubmit(e) {
    if (this.props.isCreate) {
      this.props.onSubmit(e,
        this.form.getValues(),
        InsurancePolicyActionType.CREATE_INSURANCE_POLICY_ASYNC);
    } else {
      this.props.onSubmit(e,
        this.form.getValues(),
        InsurancePolicyActionType.UPDATE_INSURANCE_POLICY_ASYNC);
    }

    e.preventDefault();
  }

  render() {
    let { name } = this.props.item;
    if (this.form) {
      name = this.form.getValues().name;
    }
    return <Modal show={this.props.show}>
      <div className='modal-header'>
        <button type='button' className='close' onClick={this.props.onCloseModal}>&times;</button>
        <h4 className='modal-title'>{this.props.title}</h4>
      </div>
      <Form ref={c => { this.form = c; }} onSubmit={this.onSubmit.bind(this)}>
        <div className='modal-body'>
          <Input type='hidden' name='id' ref='id' value={this.props.item.id} />
          <Input type='hidden' name='isActive' ref='isActive' value={this.props.item.isActive} />
          <div className='form-group'>
            <label>Insurance policy <span className='text-danger'>*</span></label>
            <Input type='text'
              autoFocus
              name='name'
              ref='name'
              value={name}
              placeholder='Insurance policy'
              className='form-control'
              max='100'
              maxLength='100'
              validations={[Vali.required, Vali.maxlength]} />
          </div >
        </div>
        <div className='modal-footer' style={{ 'display': this.props.item.readOnly ? 'none' : 'block' }}>
          <Submit className='btn btn-primary btn-siteone'>Done</Submit>
        </div>
      </Form>
    </Modal>;
  }
}




// WEBPACK FOOTER //
// ./src/Insurance/Components/add-edit-insurance-policy.js